import {
  AssignmentInd,
  AssignmentInd as AssignmentIndIcon,
  BarChart,
  DeliveryDining,
  DoNotDisturb as DoNotDisturbIcon,
  Error,
  FileDownloadDone as FileDownloadDoneIcon,
  FindInPage,
  History as HistoryIcon,
  MarkEmailRead,
  PriceCheck,
  Task,
} from "@mui/icons-material";
import EventNoteIcon from "@mui/icons-material/EventNote";

export const menuScreens = [
  // {
  //     roles: ["admin"],
  //     label: "ADMIN",
  //     icon: <Security sx={{width:"40px" ,height:"40px"}}/>,
  //     path: "/administrador/roles-permisos"
  // },
  {
    roles: ["admin", "admin.app", "agente", "tribunales"],
    label: "BUSCAR ACTA",
    icon: <HistoryIcon sx={{ width: "40px", height: "40px" }} />,
    path: "/buscar-acta",
  },
  {
    roles: ["admin", "admin.app", "agente", "tribunales"],
    label: "ACTAS",
    icon: <HistoryIcon sx={{ width: "40px", height: "40px" }} />,
    path: "/actividad",
  },
  {
    roles: ["notificador", "admin", "admin.app"],
    label: "NOTIFICAR",
    icon: <AssignmentInd sx={{ width: "40px", height: "40px" }} />,
    path: "/notificador/listado-actas",
  },
];

export const menuButtonsProceso = [
  {
    roles: ["admin", "admin.app", "agente"],
    label: "ACTAS A CHEQUEAR",
    icon: <FindInPage />,
    path: "/actas-a-chequear",
  },
  {
    roles: ["admin", "admin.app", "agente"],
    label: "ACTAS INCOMPLETAS",
    // label: "ACTAS CON DATOS DOMICILIO INCOMPLETO",
    icon: <Error />,
    path: "/actas_incompletas",
  },
  {
    roles: ["admin", "admin.app", "agente"],
    label: "ACTAS APROBADAS",
    // label: "ACTAS APROBADAS PARA IMPRIMIR",
    icon: <Task />,
    path: "/actas",
  },
  {
    roles: ["admin", "admin.app", "agente"],
    label: "ASIGNAR ACTAS",
    // label: "ASIGNAR ACTAS A NOTIFICADOR",
    icon: <AssignmentIndIcon />,
    path: "/actas-a-notificar",
  },
  {
    roles: ["admin", "admin.app", "agente"],
    label: "ACTAS EN REPARTO",
    icon: <DeliveryDining />,
    path: "/actas-asignadas-notificadores",
  },
];

export const menuButtonsResult = [
  {
    roles: ["admin", "admin.app", "tribunales", "agente"],
    label: "ACTAS NOTIFICADAS",
    icon: <MarkEmailRead />,
    path: "/actas-notificadas",
  },
  {
    roles: ["admin", "admin.app", "tribunales", "agente"],
    label: "ACTAS ABONADAS",
    icon: <PriceCheck />,
    path: "/actas-abonadas",
    buttonClass: "btn-success",
  },

  {
    roles: ["admin", "admin.app", "tribunales", "agente"],
    label: "ACTAS DESCARGO",
    icon: <FileDownloadDoneIcon />,
    path: "/actas-descargo",
  },
  {
    roles: ["admin", "admin.app", "agente"],
    label: "ACTAS ANULADAS",
    icon: <DoNotDisturbIcon />,
    path: "/actas-anuladas",
    buttonClass: "btn-danger",
  },
];

export const menuButtonsAdmin = [
  {
    roles: ["admin"],
    label: "PERMISOS",
    icon: <FindInPage />,
    path: "/permisos-test",
  },
  // {
  //   roles: ["admin"],
  //   label: "EVENTOS",
  //   // label: "ACTAS CON DATOS DOMICILIO INCOMPLETO",
  //   icon: <EventNoteIcon />,
  //   path: "/eventos",
  // },
  {
    roles: ["admin"],
    // permissions: ["JP"],
    label: "AUDITORÍA",
    icon: <EventNoteIcon />,
    path: "/auditoria",
  },
  {
    roles: ["admin"],
    permissions: ["JP"],
    label: "MONITOREO",
    icon: <BarChart />,
    path: "/monitoreo",
  },
  {
    roles: ["admin"],
    permissions: ["JP"],
    label: "AGENTES",
    icon: <BarChart />,
    path: "/agentes",
  },




  // {
  //     roles: ["admin", "admin.app"],
  //     label: "ACTAS APROBADAS",
  //     // label: "ACTAS APROBADAS PARA IMPRIMIR",
  //     icon: <Task />,
  //     path: "/actas"
  // },
  // {
  //     roles: ["admin", "admin.app"],
  //     label: "ASIGNAR ACTAS",
  //     // label: "ASIGNAR ACTAS A NOTIFICADOR",
  //     icon: <AssignmentIndIcon />,
  //     path: "/actas-a-notificar"
  // },
  // {
  //     roles: ["admin", "admin.app"],
  //     label: "ACTAS EN REPARTO",
  //     icon: <DeliveryDining />,
  //     path: "/actas-asignadas-notificadores"
  // },
  // {
  //     roles: ["admin", "admin.app", "tribunales"],
  //     label: "ACTAS NOTIFICADAS",
  //     icon: <MarkEmailRead />,
  //     path: "/actas-notificadas"
  // },
  // {
  //     roles: ["admin", "admin.app"],
  //     label: "ACTAS ABONADAS",
  //     icon: <PriceCheck />,
  //     path: "/actas-abonadas",
  //     buttonClass: "btn-success"
  // },

  // {
  //     roles: ["admin", "admin.app", "tribunales"],
  //     label: "ACTAS DESCARGO",
  //     icon: <FileDownloadDoneIcon />,
  //     path: "/actas-descargo"
  // },
  // {
  //     roles: ["admin", "admin.app"],
  //     label: "ACTAS ANULADAS",
  //     icon: <DoNotDisturbIcon />,
  //     path: "/actas-anuladas",
  //     buttonClass: "btn-danger"
  // },
];
